// React Thirty Party Library
import { Table} from "antd";

// Constants Library

// Components Library

// Handler Library

// Services Library

// Redux Actions

// Styles Library
import classes from "../index.module.css";

const DataList = ({
  paginatedData = [],
  loading,
  columnData,
  expandedRowRender,
  rowSelection,
  onChange,
}) => {

  return (
    <div>
      <Table
        className={classes.table}
        rowSelection={rowSelection}
        dataSource={paginatedData}
        columns={columnData.map((c) => ({
          ...c,
          textWrap: "word-break",
          ellipsis: true,
        }))}
        pagination={false}
        loading={loading}
        expandable={{
          expandedRowRender,
        }}
        scroll={{
          x: true,
          //x y:400
        }}
        onChange={onChange}
      />
    </div>
  );
};

export default DataList;
